import Tooltip from './tooltip';
import TooltipClick from './tooltip-click';

export default Tooltip;
export { TooltipClick };
